<template>
    <div class="mobile-form-container">
        <branding-header />

        <div class="completion-content">
            <div class="completion-header">
                <v-icon
                    v-if="icon_name"
                    :size="32"
                    :color="icon_color"
                    class="completion-icon"
                >{{ icon_name }}</v-icon>
                <h3 class="completion-title">{{ header_text }}</h3>
            </div>

            <p class="completion-description">
                {{ description_text }}
            </p>
        </div>

        <div
            v-if="is_change_request"
            class="info-section"
        >
            <h4 class="section-title">
                <v-icon
                    left
                    color="primary"
                    size="20"
                >mdi-help-circle</v-icon>
                What Happens Next?
            </h4>

            <div class="mobile-info-grid">
                <div class="mobile-info-item">
                    <div class="info-row">
                        <v-icon
                            color="primary"
                            size="18"
                            class="info-icon"
                        >mdi-clock-outline</v-icon>
                        <div class="info-content">
                            <div class="info-label">Response Time</div>
                            <div class="info-text">We'll typically respond within 1-2 business hours during our
                                operating hours.</div>
                        </div>
                    </div>
                </div>

                <div class="mobile-info-item">
                    <div class="info-row">
                        <v-icon
                            color="primary"
                            size="18"
                            class="info-icon"
                        >mdi-phone-message</v-icon>
                        <div class="info-content">
                            <div class="info-label">Contact Method</div>
                            <div class="info-text">We'll text you at {{ submission_data?.data?.phone || '(555) 123-4567'
                                }} to discuss your changes.</div>
                        </div>
                    </div>
                </div>

                <div class="mobile-info-item">
                    <div class="info-row">
                        <v-icon
                            color="primary"
                            size="18"
                            class="info-icon"
                        >mdi-calendar-clock</v-icon>
                        <div class="info-content">
                            <div class="info-label">Hours</div>
                            <div class="info-text">Monday-Friday: 9am-5pm<br>Saturday-Sunday: 10am-5pm</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BrandingHeader from '@/components/demos/shared/branding-header.vue';

export default {
    name: 'CompletionDemo',

    components: {
        BrandingHeader
    },

    props: {
        is_change_request: {
            type: Boolean,
            default: false
        },

        submission_data: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            messageIndex: 1,
            conversationKey: 0,
            showTyping: false
        }
    },

    computed: {
        has_text_consent() {
            return this.submission_data?.has_text_consent || false;
        },

        icon_color() {
            return this.is_change_request ? 'primary' : 'success';
        },

        icon_name() {
            return this.is_change_request ? 'mdi-email-check' : 'mdi-check-circle';
        },

        header_class() {
            return this.is_change_request ? 'primary--text' : 'success--text';
        },

        header_text() {
            return this.is_change_request ? 'Thank You for Your Request!' : 'Thank You for Confirming!';
        },

        description_text() {
            if (this.is_change_request) {
                return 'We\'ve received your change request and will be in touch soon via text message to help update your order.';
            }

            const confirmationBase = 'Your order details have been successfully confirmed. ';
            const consentMessage = this.has_text_consent
                ? 'You\'ll receive order updates via text message.'
                : 'We have your information on file.';

            return confirmationBase + consentMessage;
        },
    },
}
</script>

<style lang="scss" scoped>
.completion-content {
    margin-bottom: 1rem;
}

.completion-header {
    text-align: center;
    margin-bottom: 0.75rem;

    .completion-icon {
        display: block;
        margin: 0 auto 0.5rem;
    }

    .completion-title {
        font-size: 1.1rem;
        font-weight: 600;
        margin: 0;
        color: #333;
    }
}

.completion-description {
    color: var(--color-text, #666);
    font-size: 0.85rem;
    text-align: center;
    margin: 0 0 1rem 0;
    line-height: 1.3;
}

.info-section {
    background: #f8f9fa;
    border-radius: 0.5rem;
    padding: 0.75rem;
    margin-bottom: 0.75rem;
    border: 1px solid #e9ecef;

    .section-title {
        display: flex;
        align-items: center;
        font-size: 0.9rem;
        font-weight: 600;
        margin-bottom: 0.75rem;
        color: var(--v-primary-base);
        gap: 0.25rem;
    }
}

.mobile-info-grid {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.mobile-info-item {
    background: white;
    border-radius: 0.375rem;
    padding: 0.75rem;
    border: 1px solid #dee2e6;

    .info-row {
        display: flex;
        align-items: flex-start;
        gap: 0.5rem;

        .info-icon {
            margin-top: 0.125rem;
            flex-shrink: 0;
        }

        .info-content {
            flex: 1;
            min-width: 0;
            text-align: left;

            .info-label {
                font-weight: 600;
                color: var(--v-primary-base);
                font-size: 0.8rem;
                margin-bottom: 0.25rem;
            }

            .info-text {
                color: #555;
                font-size: 0.75rem;
                line-height: 1.3;
            }
        }
    }
}

:deep(.v-btn) {
    text-transform: none;
    letter-spacing: normal;

    &.v-btn--outlined {
        border-width: 1.5px;
    }
}

:deep(.v-icon) {
    font-size: 18px !important;

    &.v-icon--left {
        margin-right: 0.375rem;
    }
}
</style>
